import { combineReducers } from 'redux';
import { default as list } from 'notifications_historic/reducers/notifications_historic_list_reducers';
import { default as form } from 'notifications_historic/reducers/notifications_historic_form_reducers';

export const notification_historicReducers = combineReducers({ list, form });



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/reducers/index.js